import React from 'react';
import '../../css/RiderInsight.css';

function RiderInsight() {
  return (
    <div className='insightContainer'>
        Insight Logic Here
        </div>
  )
}

export default RiderInsight;